
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class PuAccordion extends Vue {
  @Prop({ default: false })
  selected!: boolean

  @Prop({ type: String, default: 'fade' })
  transitionName!: string

  mounted() {
    this.$nextTick(function () {
      if (this.selected) {
        this.$emit('accordion-open', this.$el)
      }
    })
  }

  toggle($event: any) {
    if (this.selected) {
      this.$emit('accordion-close', $event)
    } else {
      this.$emit('accordion-open', $event)
    }
  }
}
